<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<p class="ded"><a id="page_7">For Paul Zimmer<br/>Superman of Letters</a><a id="page_8"></a></p><a id="page_8">
</a></section><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?2c711f48